import axios from "axios";
import config from "@Config/index";

// eslint-disable-next-line import/prefer-default-export
export const fetchUniversities = async (params: any) => {
  try {
    const { data } = await axios.get(`${config.API_URL}/api/v0/regions/`, {
      params: { ...params, use_java_api: true },
    });
    return { ...data };
  } catch (error: any) {
    return { error };
  }
};
export const fetchRegions = async (params: any) => {
  try {
    const { data } = await axios.get(`${config.API_URL}/api/v0/regions/`, {
      params: { ...params, use_java_api: true },
    });
    return { ...data };
  } catch (error: any) {
    return { error };
  }
};
